import React, { useState } from 'react';
import EmailTab from './EmailTab';
import PhoneTab from './PhoneTab';

const Dashboard = ({ user, onLogout }) => {
  const [activeTab, setActiveTab] = useState('emails');

  return (
    <div className="container">
      <div className="header">
        <h1>Admin Portal</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <span>Welcome, {user.username}</span>
          <button onClick={onLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </div>
      
      <div className="tabs">
        <button
          className={`tab ${activeTab === 'emails' ? 'active' : ''}`}
          onClick={() => setActiveTab('emails')}
        >
          📧 Emails
        </button>
        <button
          className={`tab ${activeTab === 'calls' ? 'active' : ''}`}
          onClick={() => setActiveTab('calls')}
        >
          📞 Phone Calls
        </button>
      </div>
      
      <div className="tab-content">
        {activeTab === 'emails' && <EmailTab />}
        {activeTab === 'calls' && <PhoneTab />}
      </div>
    </div>
  );
};

export default Dashboard;
